
import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { GetToken, clear } from '@/libs/util'
import { Logout, ChangePwd } from '@/api/admin/user'
import md5 from 'js-md5'
import { Form } from 'view-design'
const userModule = namespace('user')
@Component
export default class MainUser extends Vue {
    // @userModule.Action handleLogOut;

    // @Prop({ default: 0 }) readonly messageUnreadCount!: number;
    userAvatar = 'admin'
    name = 'User'
    changePwdData = {
        old_password: '', // 旧密码
        password: '', // 新密码
        new_password: '', // 确认新密码
        show: false
    }
    ruleCheck = {
        old_password: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
        password: [
            {
                required: true,
                message: '请输入6-18位新密码',
                min: 6,
                max: 18,
                trigger: 'blur'
            }
        ],
        new_password: [
            {
                required: true,
                validator: (rule, value, callback) => {
                    if (this.changePwdData.password != '' && value == '') {
                        callback(new Error('确认密码不能为空'))
                    } else if (this.changePwdData.password != value) {
                        callback(new Error('密码和确认密码应相同'))
                    } else {
                        callback()
                    }
                },
                trigger: 'blur'
            }
        ]
    }
    message() {
        this.$router.push({
            name: 'message_page'
        })
    }

    handleClick(name: string) {
        switch (name) {
            case 'logout':
                this.handleLogOut()
                break
            case 'changePwd':
                this.changePwdopen()
                break
            case 'message':
                this.message()
                break
            default:
                break
        }
    }

    getname() {
        this.userAvatar = GetToken().nickname
    }
    handleLogOut() {
        Logout({}).then((res) => {
            clear()
            this.$router.push({
                name: 'login'
            })
        })
    }

    changePwdopen() {
        this.changePwdData.show = true
        ;(this.$refs.changePwdcheck as Form).resetFields()
    }
    changePwdclose() {
        this.changePwdData.show = false
        ;(this.$refs.changePwdcheck as Form).resetFields()
    }
    handleSubmit(name, type) {
        ;(this.$refs.changePwdcheck as Form).validate((valid) => {
            if (valid) {
                let param = {
                    old_pwd: md5(this.changePwdData.old_password),
                    new_pwd: md5(this.changePwdData.new_password)
                }
                ChangePwd(param).then((res) => {
                    clear()
                    this.$router.push({
                        name: 'login'
                    })
                })
            } else {
                this.$Message.error('输入错误，修改失败!')
            }
        })
    }

    created() {
        this.getname()
    }
    mounted() {}
}
